import { defineMessage } from 'services/localization';

export const messages = {
    referenceFieldText: defineMessage('reference'),
    transactionDateFieldText: defineMessage('date'),
    postingPeriodFieldText: defineMessage('posting_period'),
    reversalDateFieldText: defineMessage('reversal_date'),
    reversalEntryFieldText: defineMessage('reversal'),
    reversalDeferFieldText: defineMessage('reversal_defer'),
    departmentFieldText: defineMessage('department'),
    classFieldText: defineMessage('class'),
    locationFieldText: defineMessage('location'),
    memoFieldText: defineMessage('memo'),
    reversalDeferPositiveValue: defineMessage('yes'),
};
